// test28
(28 && 0);
